
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import tr1 from "./components/tr-1.vue";
import tr2 from "./components/tr-2.vue";
import tr3 from "./components/tr-3.vue";
import { getPreviewOrderDetail } from "@/api/api-order-service";
import PiExport from "@/components/pi-export/pi-export.vue";
@Component({
  components: {
    "pi-tr-1": tr1,
    "pi-tr-2": tr2,
    "pi-tr-3": tr3,
    PiExport
  }
})
export default class PiCashTemplate extends Vue {
  private isInput = true;
  private orderNo = "";
  private downloadHref = "#";
  private tableData: objAny = {};
  private tableDataJson: objAny = {
    orderNo: "xxxxxx",
    oprName: "xxx公司",
    merchantName: "xxx公司",
    staNameList: "xx电站、xxx充电站",
    previousBalance: "-",
    totalAmount: "-",
    serviceCharges: "-",
    transferAmount: "-",
    mchContactPerson: "xxx",
    mchPhoneNumber: "1xxx",
    bankAccountName: "xxx公司",
    bankDeposit: "xxx银行",
    bankAccountNo: "xxxxxx"
  };
  public saveTable(): void {
    this.isInput = false;
    setTimeout(() => {
      const tableid: objAny = document.getElementById("tableid") || {};
      const html =
        "<html><head><meta charset='utf-8' /></head><body><style>table{text-align: left;font-size: 16px;}td{padding:8px}.default-color {color: #666;text-align: left;}.text-left {text-align: left;}.text-right {text-align: right;}.bold-tc {font-weight: bold;text-align: center;}.bold {font-weight: bold;}.text-center {text-align: center;}.table-title {font-size: 24px;text-align: center;}</style>" +
        tableid.outerHTML +
        "</body></html>";
      // 实例化一个Blob对象，其构造函数的第一个参数是包含文件内容的数组，第二个参数是包含文件类型属性的对象
      const blob = new Blob([html], { type: "application/vnd.ms-excel" });
      const aLine: objAny = this.$refs.aLine || {};
      aLine.href = URL.createObjectURL(blob);
      aLine.click();
      this.isInput = true;
    }, 1000);
  }

  public base64 = function(s: string): string {
    const win: objAny = window;
    return win.btoa(unescape(encodeURIComponent(s)));
  };
  public format = function(s: string, c: objAny): string {
    return s.replace(/{(\w+)}/g, function(m, p) {
      return c[p];
    });
  };

  async getPreviewOrderDetail(): Promise<void> {
    const ret = await getPreviewOrderDetail({ orderNo: this.orderNo });
    if (ret.status === this.$config.apiStatus) {
      const data: objAny = ret.data[0] || {};
      for (const i in data) {
        if (this.tableData[i]) {
          this.tableData[i] = data[i];
        }
      }
    }
  }
  public cancelClick(): void {
    this.$common.goBack(this.$route, "/finance-manage/withdrawal");
  }
  mounted(): void {
    this.orderNo = "";
    this.tableData = JSON.parse(JSON.stringify(this.tableDataJson));
    const query: objAny = this.$route.query;
    const orderNo: string = query.orderNo || "";
    if (orderNo != "") {
      this.orderNo = orderNo;
      this.tableData.orderNo = orderNo;
      this.getPreviewOrderDetail();
    }
  }
}
